import { createContext, useCallback } from "react";
import { setStoredString, useStoredString } from "../../../shared/storage/storedString";

/**
 * How much of each statement shows, as Daniel's viewer switches it for the whole page (his three levels): the
 * essentials (what each statement says); details (with the agent's notes and the evidence, folded); technical
 * (the evidence open). Details is today's view, the default.
 */
export type DetailLevel = "essentials" | "details" | "technical";

export const DETAIL_LEVELS: readonly DetailLevel[] = ["essentials", "details", "technical"];
const STORAGE_KEY = "dmw.regest.detailLevel";

export const DetailLevelContext = createContext<DetailLevel>("details");

/** The viewer's level, kept across pages and visits; a stored value that isn't a level reads as details. */
export function useDetailLevel(): readonly [DetailLevel, (level: DetailLevel) => void] {
  const stored = useStoredString(STORAGE_KEY);
  const level = DETAIL_LEVELS.find((each) => each === stored) ?? "details";
  const choose = useCallback((next: DetailLevel) => { setStoredString(STORAGE_KEY, next === "details" ? null : next); }, []);
  return [level, choose] as const;
}
